'use strict';

angular.module('mean.accounts-receivable').directive('projErrorMsg', [
    function(){
    return {
        template: "<h3>Project Trade Totals Errors</h3>" +
            "<p>Could not find trade totals for projects:" + 
            " {{directiveData.projects}}!</p><br><br><p>To clear this error go to " + 
            "Bidding Control, click Review, and Update Totals for each project. " +
            "Then go to Project Information and verify lots are still set to their proper revision.</p>"
    };
}]);


// WEBPACK FOOTER //
// ./packages/custom/accounts-receivable/public/directives/proj-error-msg.js